const truncateToOneDecimal = (value) => Math.trunc(value * 10) / 10;

export default truncateToOneDecimal;
